import { render, staticRenderFns } from "./upload-img.vue?vue&type=template&id=593b7bdc&"
import script from "./upload-img.vue?vue&type=script&lang=js&"
export * from "./upload-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports